/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_TitleInputs */

const en_tokens_title = /** @type {(inputs: Tokens_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API tokens`)
};

const de_tokens_title = /** @type {(inputs: Tokens_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Tokens`)
};

/**
* | output |
* | --- |
* | "API tokens" |
*
* @param {Tokens_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_title = /** @type {((inputs?: Tokens_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_title(inputs)
	return en_tokens_title(inputs)
});